module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  })], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.isSearching,
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "height": _vm.calcDialogScroll(48 + 48 + 52 + 102, 48 + 48 + 52 + 116)
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Введите список инн компаний",
      "hint": "Инн могут разделяться пробелами или запятыми, можно также вводить ОГРН (ogrn:1111111111111), НЗА (nza:11111111111), ОГРНИП (ogrnip:111111111111111)",
      "value": _vm.cxt.selectedIds,
      "clearable": "",
      "persistent-hint": "",
      "rows": "16",
      "autofocus": ""
    },
    on: {
      "input": _vm.setSelectedIds
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-046dcb4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ListSelectorTab.vue
// module id = 879
// module chunks = 1